export default {

    SET_ACCESS_TOKEN (state, data) {
        state.accessToken = data
    },

    SET_REFRESH_TOKEN  (state, data) {
        state.refreshToken = data
    },

    SET_ID_TOKEN  (state, data) {
        state.idToken = data
    },

    SET_USER_INFO (state, data) {
        state.userInfo = data
    },

    SET_USER_STATUS (state, data) {
        state.userStatus = data
    },

    SET_ERROR(state, data){
        state.error = data
    },

    SET_TIMER(state, value){
        state.reSendCurrentTime = value
    },

    SET_TIME_INTERVAL(state, value){
        state.timerInterval = value
    }

}
